
import _ from 'lodash';
import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Form, Grid, Icon, Label } from 'semantic-ui-react';
import { FormContext } from '../../../cnr/contexts/FormContext';
import { uniqueKey } from '../../../common/keys';
import { appIconTypes } from '../../../enums/appIconTypes';
import { gEnums } from '../../../enums/globalEnums';
import ThemedColors from '../elements/ThemedColors';

const WAIT_INTERVAL = 1000;

const ItemMap = (props) => {

  const fits = gEnums.formItemTypes

  const { fip, formItemType, labelProps, themeColors } = props
  const { itemProp, propname, label } = fip ?? {}

  const _itemProp = itemProp ? itemProp : propname

  const formContext = useContext(FormContext)
  const { form_state } = formContext ?? {}
  const { optionsList } = form_state ?? {}

  let startValue = fip.value && fip.value.length > 0 ? fip.value : null

  switch (formItemType) {
    case fits.itemMap:
      const defaultItems = []
      if (startValue) {
        Object.keys(startValue).forEach(key => {
          defaultItems.push({ key: key, value: startValue[key] })
        })
        startValue = defaultItems
      }
      break;
    default:
      break;
  }

  const [addReady, setAddReady] = useState(true)
  const [formData, updateFormData] = useState([])
  const [items, setItems] = useState(startValue)
  const [dataChanged, setDataChanged] = useState(false)
  const [showRedirect, setShowRedirect] = useState(false)

  const inputRef = useRef(null);

  const triggerChange = () => {
    if (dataChanged) {
      updateMapParent()
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => triggerChange(formData), WAIT_INTERVAL);
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [formData]);

  useEffect(() => {
    if (labelProps) {
      _.forEach(labelProps, (labelProp) => {
        if (labelProp.prop && labelProp.prop === 'redirectUrl') {
          setShowRedirect(true)
        }
      })
    }
    // eslint-disable-next-line
  }, [labelProps]);

  const handleChange = (e, data) => {
    const newValue = setChangeValue(data)
    updateFormData(newValue)
    setDataChanged(true)
  }

  const testLink = (e, item) => {
    let url = item.appUrl
    if (url.indexOf('https://') < 0) { url = 'https://' + url }
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    window.open(url, '_blank');
  }

  const getShortUrl = (item) => {
    let url = item.host
    if (url.indexOf('https://') < 0) { url = 'https://' + url }
    url += '/#/' + item.shortUrl
    return url
  }

  const testRedirect = (e, item) => {
    let url = getShortUrl(item)
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    window.open(url, '_blank');
  }

  const handleCopy = async (text) => {
    await navigator.clipboard.writeText(text);
    alert("Copied!");
  }

  const setChangeValue = (data) => {

    const newItems = [...items]
    const { value, ii, propname } = data

    switch (propname) {
      case 'appTest':
        break;
      default:
        switch (formItemType) {
          case fits.itemMap:
            const item2 = newItems[ii]
            if (data.type === 'checkbox') {
              item2[propname] = data.checked
            } else {
              item2[propname] = value
            }
            break;
          case fits.itemArrayMulti:
            const item3 = newItems[ii]
            if (data.type === 'checkbox') {
              item3[propname] = data.checked
            } else {
              item3[propname] = value
            }
            break;
          default:
          // nothing
        }
    }
    return newItems
  }

  const updateMapParent = () => {

    switch (formItemType) {

      case fits.itemMap:
        // convert to map
        const mapItems = {}
        if (labelProps) {
          const lbk = labelProps[0].prop
          const lbv = labelProps[1].prop
          items.forEach(item => { mapItems[item[lbk]] = item[lbv] })
        } else {
          items.forEach(item => { mapItems[item.key] = item.value })
        }
        const pd2 = {
          propname: _itemProp,
          value: mapItems
        }
        fip.onChange(null, pd2)
        break;

      case fits.itemArrayMulti:
        // convert to map
        const parentItems3 = []
        items.forEach(item => { parentItems3.push(item) })
        const pd3 = {
          propname: fip.propname,
          value: parentItems3
        }
        fip.onChange(null, pd3)
        break;

      default:
      // nothing
    }
  }

  const handleAdd = () => {

    const i = Object.assign([], items)

    switch (formItemType) {
      case fits.itemMap:
        if (labelProps) {
          const xm = {}
          labelProps.forEach(lbl => {
            xm[lbl.prop] = null
          })
          i.push(xm)
        } else {
          i.push({ key: null, value: null })
        }
        setAddReady(true)
        setItems(i)
        break;

      case fits.itemArrayMulti:
        if (labelProps) {
          const x = {}
          labelProps.forEach(lbl => {
            x[lbl.prop] = null
          })
          i.push(x)
        } else {
          i.push({ prop: null, value: null, setting: null })
        }
        setAddReady(true)
        setItems(i)
        break;

      default:
      // nothing
    }
  }

  const handleRemove = (index) => {

    const i = Object.assign([], items)

    switch (formItemType) {
      // case fits.array:
      case fits.itemArrayMulti:
        i.splice(index, 1)
        if (i.length === 0) {
          setItems(null)
        } else {
          setItems(i)
        }
        const pd_m = {
          propname: _itemProp,
          value: i
        }
        fip.onChange(null, pd_m)
        break;

      case fits.itemMap:
        delete i[index]
        const parentItems3 = []
        i.forEach(item => { parentItems3.push(item) })
        const pd = {
          propname: _itemProp,
          value: parentItems3
        }
        setItems(i)
        fip.onChange(null, pd)
        break;
      default:
      // nothing
    }
  }

  const formSelect = (ii, propname, value, ol, caption) => <Form.Select
    key={uniqueKey('im', 'fs', propname)}
    placeholder={propname}
    propname={propname}
    label={(caption ? caption : null)}
    ii={ii}
    onChange={handleChange}
    fluid
    options={ol}
    value={value}
  />

  const formDropdownGroup = (ii, propname, value, ol) => <Form.Dropdown
    key={uniqueKey('im', 'fdd', propname)}
    value={value}
    placeholder={propname}
    propname={propname}
    options={ol}
    fluid
    search
    selection
    multiple
    onChange={handleChange}
    ii={ii}
    className='full-row swiper-no-swiping'
  />

  const input = (ii, propname, value, caption) => {
    if (propname.indexOf('color') >= 0) {
      const fip = { propname: propname, onChange: handleChange, ii, value: value }
      return <ThemedColors fip={fip} themeColors={themeColors} itemProp={_itemProp} isSimple={true} />
    } else {
      return <Form.Input
        key={uniqueKey('im', 'inp', propname)}
        placeholder={propname}
        propname={propname}
        inputRef={inputRef}
        // ref={propname === 'shortUrl' ? textAreaRef : null}
        label={(caption ? caption : _.startCase(propname))}
        ii={ii}
        onChange={handleChange}
        value={value}
      />
    }
  }

  const checkbox = (ii, propname, checked, caption) => <Form.Checkbox
    key={uniqueKey('im', 'cb', propname)}
    propname={propname}
    toggle
    label={(caption ? caption : null)}
    checked={checked}
    ii={ii}
    onChange={handleChange}
  />

  // const gridRowArray = (ii, item) => {
  //   return <Grid.Row key={uniqueKey('im', 'gra')} columns={3}>
  //     <Grid.Column key={uniqueKey('im', 'gra1')} width={2}><Label>{ii}</Label></Grid.Column>
  //     <Grid.Column key={uniqueKey('im', 'gra2')} width={12}>{input(ii, 'value', item.value)}</Grid.Column>
  //     <Grid.Column key={uniqueKey('im', 'gra3')} width={2}><Icon name={appIconTypes.delete} color='grey' bordered style={{ float: 'right' }} onClick={e => handleRemove(ii)}></Icon></Grid.Column>
  //   </Grid.Row>
  // }

  const gridRowMap = (ii, item) => {

    const k = item.key
    const v = item.value

    if (labelProps) {

      const gridCols = []

      labelProps.forEach((lbl, lblIndex) => {
        const { data, prop, caption } = lbl
        const { formItemType, listType } = data
        let elem = null
        switch (formItemType) {
          case gEnums.formItemTypes.text:
            elem = input(lblIndex, prop, item[prop], caption)
            break;
          case gEnums.formItemTypes.select:
            const ol = listType && optionsList[listType] ? optionsList[listType] : []
            elem = formSelect(lblIndex, prop, item[prop], ol, caption)
            break;
          case gEnums.formItemTypes.dropdownGroup:
            const dol = listType && optionsList[listType] ? optionsList[listType] : []
            elem = formDropdownGroup(lblIndex, prop, item[prop], dol)
            break;
          case gEnums.formItemTypes.checkbox:
            elem = checkbox(lblIndex, prop, item[prop], caption)
            break;
          default:
            break;
        }
        gridCols.push(<Grid.Column key={uniqueKey('im', 'grm', lblIndex)} width={12}>{elem}</Grid.Column>)
      })

      return <Grid.Row key={uniqueKey('im', 'grm', 'r')} columns={3}>
        <Grid.Column key={uniqueKey('im', 'grm', 'c')} width={2}><Label>{ii}</Label></Grid.Column>
        {gridCols}
        <Grid.Column key={uniqueKey('im', 'grm', 'c')} width={2}><Icon name={appIconTypes.delete} color='grey' bordered style={{ float: 'right' }} onClick={e => handleRemove(ii)}></Icon></Grid.Column>
      </Grid.Row>

    } else {
      return <Grid.Row key={uniqueKey('im', 'grm', 'r')} columns={4}>
        <Grid.Column key={uniqueKey('im', 'grm', 1)} width={2}><Label>{ii}</Label></Grid.Column>
        <Grid.Column key={uniqueKey('im', 'grm', 2)} width={6}>{input(ii, 'key', k)}</Grid.Column>
        <Grid.Column key={uniqueKey('im', 'grm', 3)} width={6}>{input(ii, 'value', v)}</Grid.Column>
        <Grid.Column key={uniqueKey('im', 'grm', 4)} width={2}><Icon name={appIconTypes.delete} color='grey' bordered style={{ float: 'right' }} onClick={e => handleRemove(ii)}></Icon></Grid.Column>
      </Grid.Row>
    }
  }

  const gridRowMapMulti = (ii, item) => {

    if (labelProps) {

      const vvds = []
      const btns_l = []
      const btns_r = []
      let copyText;

      labelProps.forEach((lbl, lblIndex) => {

        const { data, prop } = lbl ?? {}
        const { formItemType, listType, caption } = data ?? {}

        switch (prop) {
          case 'shortUrl':
            copyText = getShortUrl(item)
            break;
          default:
          // nothing
        }

        switch (formItemType) {
          case gEnums.formItemTypes.text:
            vvds.push(input(ii, prop, item[prop], caption))
            break;
          case gEnums.formItemTypes.select:
            const ol = listType ? optionsList[listType] : []
            vvds.push(formSelect(ii, prop, item[prop], ol, caption))
            break;
          case gEnums.formItemTypes.dropdownGroup:
            const dol = listType ? optionsList[listType] : []
            vvds.push(formDropdownGroup(ii, prop, item[prop], dol))
            break;
          case gEnums.formItemTypes.checkbox:
            vvds.push(checkbox(ii, prop, item[prop]), caption)
            break;
          case gEnums.formItemTypes.button:
            vvds.push(<Button onClick={e => testLink(e, item)}>Test Link</Button>)
            break;
          default:
            vvds.push(input(ii, prop, item[prop]))
            break;
        }
      })

      btns_l.push(<Icon name={appIconTypes.delete} color='red' bordered onClick={e => handleRemove(ii)}></Icon>)

      copyText && btns_r.push(<Button color='blue' size='mini' onClick={e => handleCopy(copyText)}>Copy</Button>)
      showRedirect && btns_r.push(<Button color='blue' size='mini' onClick={e => testRedirect(e, item)}>Test Redirect</Button>)

      return <div className='item-map'>
        <div className='item-map-header'>{ii}</div>
        <div className='item-map-items'>{vvds}</div>
        <div className='item-map-footer-l'>{btns_l}</div>
        <div className='item-map-footer-r'>{btns_r}</div>
      </div>


      // return <Grid.Row key={uniqueKey('im', 'gr')} columns={3} stretched>
      //   <Grid.Column key={uniqueKey('im', 'gr', 1)} width={1}><Label>{ii}</Label></Grid.Column>
      //   <Grid.Column key={uniqueKey('im', 'gr', 2)} width={14}>{vvds}</Grid.Column>
      //   <Grid.Column key={uniqueKey('im', 'gr', 3)} width={1}><Icon name={appIconTypes.delete} color='grey' bordered style={{ float: 'right' }} onClick={e => handleRemove(ii)}></Icon></Grid.Column>
      // </Grid.Row>
    } else {
      return <div className='item-map'>
        <div className='item-map-header'>{ii}</div>
        <div className='item-map-items'>{input(ii, 'prop', item.prop)}{input(ii, 'value', item.value)}{input(ii, 'setting', item.setting)}</div>
        <div className='item-map-footer-l'>{btns_l}</div>
        <div className='item-map-footer-r'>{btns_r}</div>
      </div>
      // return <Grid.Row key={uniqueKey('im', 'gr')} columns={3} stretched>
      //   <Grid.Column key={uniqueKey('im', 'gr', 1)} width={1}><Label>{ii}</Label></Grid.Column>
      //   <Grid.Column key={uniqueKey('im', 'gr', 2)} width={14}>{input(ii, 'prop', item.prop)}{input(ii, 'value', item.value)}{input(ii, 'setting', item.setting)}</Grid.Column>
      //   <Grid.Column key={uniqueKey('im', 'gr', 3)} width={1}><Icon name={appIconTypes.delete} color='grey' bordered style={{ float: 'right' }} onClick={e => handleRemove(ii)}></Icon></Grid.Column>
      // </Grid.Row>
    }
  }

  const listItemGrid = (isArray, ii, item, key) => {
    return <div className='item-map-container'>
      {!isArray && formItemType === fits.itemMap && gridRowMap(ii, item)}
      {formItemType === fits.itemArrayMulti && gridRowMapMulti(ii, item)}
    </div>
    // return <List.Item kkey={uniqueKey('im', 'lig')}>
    //   <List.Content>
    {/* <Grid key={uniqueKey('im', 'lig', 'g')} className={'grid-text-map'}> */ }
    // { isArray && gridRowArray(ii, item) }
    // { !isArray && formItemType === fits.itemMap && gridRowMap(ii, item) }
    // { formItemType === fits.itemArrayMulti && gridRowMapMulti(ii, item) }
    {/* </Grid> */ }
    //   </List.Content>
    // </List.Item>
  }

  const gridListItems = () => {
    const listItems = []
    if (items) {
      try {
        switch (formItemType) {
          case fits.itemMap:
            items.forEach((item, ii) => {
              if (labelProps) {
                listItems.push(listItemGrid(false, ii, item))
              } else {
                listItems.push(listItemGrid(false, ii, item))
              }
            })
            break;
          case fits.itemArrayMulti:
            items.forEach((item, ii) => {
              listItems.push(listItemGrid(false, ii, item))
            })
            break;
          default:
          // nothing
        }
      } catch (error) {
        console.error(error)
      }
    }
    return listItems
  }

  const list = () => {
    return <div className='item-map-list'>
      <div>
        <label className={'form-label'} style={{ fontWeight: 700 }}>{label}</label>
        <Icon disabled={!addReady} name={appIconTypes.add} color='green' bordered style={{ float: 'right' }} onClick={e => handleAdd()}></Icon>
      </div>
      <div>
        {gridListItems()}
      </div>
    </div>
    // return <List key={uniqueKey('im', 'l')}>
    //   <List.Item key={uniqueKey('im', 'li')}>
    //     <label className={'form-label'} style={{ fontWeight: 700 }}>{label}</label>
    //     <Icon disabled={!addReady} name={appIconTypes.add} color='green' bordered style={{ float: 'right' }} onClick={e => handleAdd()}></Icon>
    //     <div>
    //       <List.List>
    //         {gridListItems()}
    //       </List.List>
    //     </div>
    //   </List.Item>
    // </List>
  }

  return list()

}

export default ItemMap